/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import MARKDOWN_RENDERER from "../sini_v2_full/MARKDOWN_RENDERER";
import S_D_CHAT_GRAPH from "./S_D_CHAT_GRAPH";
import S_D_CONVERT from "./S_D_CONVERT";
import Filter from "../sidebar_map_right/Filter";
import BouncingDotsLoader from "../loadinng_sini_ai/BouncingDotsLoader";
import ICON_PLUS_RAW from "../../Assets/jsx/ICON_PLUS_RAW";

/*REDUX*/
import { set_value_sini_data } from "../../App/actions/sini_data_actions";

import { get_recomendation } from "../../App/actions/ai_preset_actions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

class S_D_CHAT extends Component {
  state = {
    modal_convert: false,
  };

  on_new_chat = () => {
    const layer_id = this.props.layer.layer_id;
    this.props.get_recomendation(layer_id);
    this.props.set_value_sini_data({
      key: "prompt_text",
      value: "",
    });
    this.props.set_value_sini_data({
      key: "rows_text_area",
      value: 1,
    });
    this.props.set_value_sini_data({
      key: "request_id",
      value: "",
    });
    this.props.set_value_sini_data({
      key: "chat_list",
      value: [],
    });
  };

  toggle_convert = (current_chat) => {
    this.setState({
      modal_convert: !this.state.modal_convert,
    });
    if (current_chat) {
      this.props.set_value_sini_data({
        key: "current_chat",
        value: current_chat,
      });
    }
  };

  on_change = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({ [name]: value });
  };

  render() {
    //local storage

    //local state
    const { modal_convert } = this.state;
    // const { estimated_token_used, token_open_ai } =
    //   this.props.sini_data_reducer;

    // const sisa = token_open_ai - estimated_token_used;
    // //global props
    const language = localStorage?.language || this.props.auth.language;

    const { chat_list, convert_text_to_number_object, convert_progress } =
      this.props.sini_data_reducer;
    const { loading_item_array } = this.props.loading_reducer;
    const last_bot_index = [...chat_list]
      .map((c, i) => ({ i, isBot: c.role === "assistant" }))
      .filter((x) => x.isBot)
      .map((x) => x.i)
      .pop();

    //content
    const modal_convert_content = modal_convert && (
      <Modal
        modalSize="large"
        isOpen={modal_convert}
        onClose={this.toggle_convert}
      >
        <div className="box-body">
          <S_D_CONVERT
            toggle_convert={this.toggle_convert}
            mode_edit="sini_ai"
          />
        </div>
      </Modal>
    );

    return (
      <main style={{ marginBottom: "200px" }}>
        {modal_convert_content}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* <div
            className="text_small"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            Besar Data:{" "}
            <span
              style={{
                color: `${sisa < 0 ? "red" : "black"}`,
              }}
            >
              {new Intl.NumberFormat("id-ID", { style: "decimal" }).format(
                estimated_token_used
              )}{" "}
              /{" "}
              {new Intl.NumberFormat("id-ID", { style: "decimal" }).format(
                token_open_ai
              )}{" "}
              <span>{sisa < 0 ? "(Over)" : "(Under)"}</span>
            </span>
          </div> */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <button
              style={{
                display: "flex",

                alignItems: "center",
              }}
              className="button_big background_black text_white margin_bottom"
              onClick={this.on_new_chat}
            >
              <ICON_PLUS_RAW
                color="#ffffff"
                style={{
                  width: "15px",
                  marginRight: "5px",
                }}
              />{" "}
              {dict?.["New Chat"]?.[language]}
            </button>
          </div>
        </div>

        {chat_list.map((item, idx) => {
          const role = item?.role;
          const is_user = role === "user";
          const result_list = item?.result_list || [];

          return (
            <div
              key={idx}
              style={{
                display: "flex",
                justifyContent: is_user ? "flex-end" : "flex-start",
              }}
            >
              <div
                className={`container margin_bottom text_medium ${
                  is_user ? "background_black" : "background_grey_light"
                }`}
                style={{
                  maxWidth: "100%",
                  padding: "10px",
                  borderRadius: "10px",
                  color: is_user ? "white" : "black",
                  width: "260px",
                  display: "inline-block",
                }}
              >
                <MARKDOWN_RENDERER markdownContent={item.content} />
                {item?.layer_action_list?.[0]?.includes("gen_color") && (
                  <div className="margin_top container background_white">
                    <p className="text_medium sub_color margin_bottom">
                      {
                        dict?.[
                          "Are there any problems with the styling results?"
                        ]?.[language]
                      }
                    </p>
                    <button
                      className="button_big button_white outline_black"
                      onClick={this.toggle_convert.bind(this, item)}
                    >
                      {dict?.["Yes, help resolve"]?.[language]}
                    </button>
                  </div>
                )}
                {result_list.length > 0 && (
                  <>
                    {!is_user &&
                      idx === last_bot_index &&
                      result_list[0].result_object?.gen_filter?.length > 0 && (
                        <Filter />
                      )}

                    {result_list[0].result_object?.gen_graph && (
                      <S_D_CHAT_GRAPH result_list={result_list} />
                    )}
                  </>
                )}
              </div>
            </div>
          );
        })}

        {/* <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          <div
            className={`container margin_bottom text_medium background_grey_light`}
            style={{
              maxWidth: "100%",
              padding: "10px",
              borderRadius: "10px",
              color: "black",
              width: "260px",
              display: "inline-block",

            }}
          >
            <div className="sini_container_animation">
              <div className="sini_shape_animation"></div>
              <div className="sini_shape_animation"></div>
              <div className="sini_shape_animation"></div>
            </div>
          </div>
        </div> */}

        {/* <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          <div
            className={`container margin_bottom text_medium background_grey_light`}
            style={{
              maxWidth: "100%",
              padding: "10px",
              borderRadius: "10px",
              color: "black",
              width: "260px",
              display: "inline-block",
            }}
          >
            <span className="bubble_animation">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </div>
        </div> */}

        {
          loading_item_array.includes("gen_action") && (
            <div>
              <br />
              <BouncingDotsLoader />
            </div>
          )

          // <div
          //   style={{
          //     display: "flex",
          //     justifyContent: "flex-start",
          //   }}
          // >
          //   <div
          //     className={`container margin_bottom text_medium background_grey_light`}
          //     style={{
          //       maxWidth: "100%",
          //       padding: "10px",
          //       borderRadius: "10px",
          //       color: "black",
          //       width: "260px",
          //       display: "inline-block",
          //     }}
          //   >
          //     <div className="sini_container_animation">
          //       <div className="sini_shape_animation"></div>
          //       <div className="sini_shape_animation"></div>
          //       <div className="sini_shape_animation"></div>
          //     </div>
          //   </div>
          // </div>
        }

        {convert_text_to_number_object?.layer_id &&
          convert_progress === "pending" &&
          !loading_item_array.includes("gen_action") && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <div
                className={`container margin_bottom text_medium background_grey_light`}
                style={{
                  maxWidth: "100%",
                  padding: "10px",
                  borderRadius: "10px",
                  color: "black",
                  width: "260px",
                  display: "inline-block",
                }}
              >
                <p className="margin_bottom">
                  {dict?.["Number column repair path"]?.[language]}
                </p>
                <button
                  className="button background_black"
                  onClick={this.toggle_convert}
                >
                  {dict?.["Run now"]?.[language]}
                </button>
              </div>
            </div>
          )}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  layer: state.layer,
  auth: state.auth,
  project: state.project,
  loading_reducer: state.loading_reducer,
  sini_data_reducer: state.sini_data_reducer,
});

export default connect(mapStateToProps, {
  set_value_sini_data,
  get_recomendation,
})(S_D_CHAT);
